import Ad from "../gpt/Ad";
import GPT from "../gpt/GPT";
import FallbackAd from "../taglessAd/FallbackAd";
import TaglessAd from "../taglessAd/TaglessAd";
import AdObserver from "../util/AdObserver";

const defaultObserverOptions: IntersectionObserverInit = { threshold: 0.5 };

export default class IntersectionObserverRenderingStrategy {

    /**
     * @constructor
     * @param {GPT} gpt
     * @param {Number} adThreshold
     */

    _gpt: GPT;
    _gamTaglessAd: TaglessAd;
    _isTaglessAdEnabled: boolean;
    _fallbackAd: FallbackAd;
    _showFallbackAds: boolean;
    _renderAdObserver: AdObserver;
    _refreshAdObserver: AdObserver;

    constructor(
        gpt: GPT,
        gamTaglessAd: TaglessAd,
        isTaglessAdEnabled: boolean,
        fallbackAd: FallbackAd,
        showFallbackAds: boolean,
        renderObserverOptions = defaultObserverOptions,
        refreshObserverOptions = defaultObserverOptions
    ) {
        this._gpt = gpt;
        this._gamTaglessAd = gamTaglessAd;
        this._isTaglessAdEnabled = isTaglessAdEnabled;
        this._fallbackAd = fallbackAd;
        this._showFallbackAds = showFallbackAds;
        this._renderAdObserver = new AdObserver(this._renderCallback.bind(this), renderObserverOptions);
        // different IntersectionObserver for refresh
        // so we don't have to use same rootMargin as render IntersectionObserver
        this._refreshAdObserver = new AdObserver(this._refreshCallback.bind(this), refreshObserverOptions);
    }

    _renderCallback(ad: Ad) {
        const containerId = ad.getContainerId();

        if (this._isTaglessAdEnabled && containerId.includes("leaderboard")) {
            this._gamTaglessAd.render(ad);
        } else {
            this._gpt.render(ad, { services: [this._gpt.services.pubads] });
        }
    }

    _refreshCallback(ad: Ad) {
        if (ad.hasSlot()) {
            this._gpt.refresh([ad]);
        } else {
            this._renderCallback(ad);
        }
    }

    start() {
        this._renderAdObserver.start();
        this._refreshAdObserver.start();
    }

    stop() {
        this._renderAdObserver.stop();
        this._refreshAdObserver.stop();
    }

    destroy() {
        this._renderAdObserver.destroy();
        this._refreshAdObserver.destroy();
    }

    render(ad: Ad) {
        if (this._showFallbackAds) {
            this._fallbackAd.render(ad);
        } else {
            this._renderAdObserver.startObserving(ad);
        }
    }

    refresh(ads: Ad[]) {
        ads.forEach((ad) => {
            if (ad.isDisplayable()) {
                this._refreshAdObserver.startObserving(ad);
            }
        });
    }

    setFallbackFlag(flag: boolean) {
        this._showFallbackAds = flag;
    }

}
